import { useNavigate } from "react-router";
import { useState } from "react";
import styles from "./index.module.css";

const StoreCard = (props) => {
  const navigate = useNavigate();
  const [isGraphView, setIsGraphView] = useState(false);

  const onViewClick = (e) => {
    const storeName = e?.target?.dataset?.store;
    const terminal = props?.terminal;
    const storeParam = encodeURIComponent(`${storeName} (${terminal})`);
    navigate(`/dashboard/fnb-products?store=${storeParam}`);
  };

  const toggleView = () => {
    setIsGraphView(!isGraphView);
  };

  const getMaxValue = () => {
    return Math.max(
      props?.tp?.value || 0,
      props?.ep?.value || 0,
      props?.mp?.value || 0,
      props?.cp?.value || 0
    );
  };

  const renderGraphicalView = () => {
    const maxValue = getMaxValue();
    return (
      <div className={styles.graphContainer}>
        <div className={styles.graphItem}>
          <div className={styles.graphLabel}>
            <span style={{ color: '#028D7F' }}>●</span>
            Total Products
          </div>
          <div className={styles.graphBarContainer}>
            <div 
              className={styles.graphBar} 
              style={{ 
                width: `${(props?.tp?.value / maxValue) * 100}%`,
                backgroundColor: '#028D7F'
              }}
            />
            <span className={styles.graphValue}>{props?.tp?.value}</span>
          </div>
        </div>
        <div className={styles.graphItem}>
          <div className={styles.graphLabel}>
            <span style={{ color: '#19A74A' }}>●</span>
            Expensive Products
          </div>
          <div className={styles.graphBarContainer}>
            <div 
              className={styles.graphBar} 
              style={{ 
                width: `${(props?.ep?.value / maxValue) * 100}%`,
                backgroundColor: '#19A74A'
              }}
            />
            <span className={styles.graphValue}>{props?.ep?.value}</span>
          </div>
        </div>
        <div className={styles.graphItem}>
          <div className={styles.graphLabel}>
            <span style={{ color: '#FFB74D' }}>●</span>
            Midrange Products
          </div>
          <div className={styles.graphBarContainer}>
            <div 
              className={styles.graphBar} 
              style={{ 
                width: `${(props?.mp?.value / maxValue) * 100}%`,
                backgroundColor: '#FFB74D'
              }}
            />
            <span className={styles.graphValue}>{props?.mp?.value}</span>
          </div>
        </div>
        <div className={styles.graphItem}>
          <div className={styles.graphLabel}>
            <span style={{ color: '#FF9999' }}>●</span>
            Cheapest Products
          </div>
          <div className={styles.graphBarContainer}>
            <div 
              className={styles.graphBar} 
              style={{ 
                width: `${(props?.cp?.value / maxValue) * 100}%`,
                backgroundColor: '#FF9999'
              }}
            />
            <span className={styles.graphValue}>{props?.cp?.value}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles["store_box"]}>
      <div className={styles["box_head"]}>
        <div>
          <div>{props?.title}</div>
          <div>{props?.terminal}</div>
        </div>
        <div 
          className={styles.viewToggle} 
          onClick={toggleView}
          data-view={isGraphView ? "graph" : "text"}
        >
          {isGraphView ? "Text View" : "Graph View"}
        </div>
      </div>
      <div className={styles["box_content"]}>
        {isGraphView ? (
          renderGraphicalView()
        ) : (
          <>
        <div className={styles["box_item"]}>
          <div>Total Products</div>
          <div className={styles["box_item--container"]}>
            <div className={styles["box_item--value"]}>{props?.tp?.value}</div>
          </div>
        </div>
        <div className={styles["box_item"]}>
          <div>Expensive Products</div>
          <div className={styles["box_item--container"]}>
            <div className={styles["box_item--value"]}>{props?.ep?.value}</div>
          </div>
        </div>
        <div className={styles["box_item"]}>
          <div>Midrange Products</div>
          <div className={styles["box_item--container"]}>
            <div className={styles["box_item--value"]}>{props?.mp?.value}</div>
          </div>
        </div>
        <div className={styles["box_item"]}>
          <div>Cheapest Products</div>
          <div className={styles["box_item--container"]}>
            <div className={styles["box_item--value"]}>{props?.cp?.value}</div>
          </div>
        </div>
          </>
        )}
      </div>
      <div className={styles["box_cta"]}>
        <div
          className={styles["button"]}
          data-store={props?.title}
          onClick={onViewClick}
        >
          View More
        </div>
      </div>
    </div>
  );
};

export default StoreCard;
